export const USERCONNECTOR = '[USERCONNECTOR]';

// action types
export const FETCH_USERCONNECTOR = `${USERCONNECTOR} FETCH`;
export const SET_USERCONNECTOR = `${USERCONNECTOR} SET`;
export const FETCH_USERCONNECTORS = `${USERCONNECTOR} FETCH ALL`;

const getScopePayload = (scope) =>
  scope !== undefined && scope !== null && scope !== '' ? { scope } : undefined;

export const fetchUserConnectors = (scope) => ({
  type: FETCH_USERCONNECTORS,
  payload: getScopePayload(scope),
  method: 'GET',
  api: 'kinects',
  endPoint: 'userconnector',
  function: 'getUserConnectors',
});

export const fetchUserConnector = (id, scope) => ({
  type: FETCH_USERCONNECTOR,
  payload: getScopePayload(scope),
  method: 'GET',
  api: 'kinects',
  endPoint: `userconnector/${id}`,
  function: 'getUserConnector',
});

export const setUserConnector = ({ userConnectors }) => ({
  type: SET_USERCONNECTOR,
  payload: userConnectors,
});
